module.exports = __webpack_public_path__ + "img/logo.a0a2f37c.svg";